function googleTranslateElementInit() {
    new google.translate.TranslateElement(
        {
            pageLanguage: 'sv',
            includedLanguages: 'sv,en,da,no,fi,fr,de,es'
        },
        'google_translate_element'
    );
}

document.addEventListener("DOMContentLoaded", function () {
    "use strict";

    // Lägg till Google Translate scriptet
    const script = document.createElement("script");
    script.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
    script.defer = true;
    document.head.appendChild(script);

    let placeholders = Array.from(document.querySelectorAll("input[placeholder]"));
    if (placeholders.length > 0) {
        const div = document.createElement("div");
        div.id = "placeholders";
        div.style.display = "none";
        document.body.appendChild(div);

        placeholders.forEach(input => {
            const phDiv = document.createElement("div");
            phDiv.textContent = input.placeholder;
            div.appendChild(phDiv);
        });

        let originalPH = placeholders[0].placeholder;

        function isTranslated() {
            const currentPH = document.querySelector("#placeholders > div").textContent;
            return originalPH !== currentPH;
        }

        function updatePlaceholders() {
            document.querySelectorAll("#placeholders > div").forEach((div, i) => {
                placeholders[i].placeholder = div.textContent;
            });
        }

        setInterval(function () {
            if (isTranslated()) {
                updatePlaceholders();
                originalPH = placeholders[0].placeholder;
            }
        }, 500);
    }

    document.addEventListener("click", function (e) {
        const btn = e.target.closest(".clear-translate");
        if (!btn) return;

        try {
            const iframe = Array.from(document.querySelectorAll("iframe"))
                .find(f => f.id.startsWith(":"));
            if (!iframe) return;

            const restoreBtn = iframe.contentDocument.getElementById(":1.restore");
            if (restoreBtn) {
                restoreBtn.click();
            }
        } catch (err) {
            console.warn("Kunde inte nå restore-knappen i iframen:", err);
        }
    });

});
//# sourceMappingURL=google-translate.js.map
